import { REQUEST_APPROVAL_LIST_SUCCESS, REQUEST_APPROVAL_LIST_FAILURE } from '../constants/actionTypes';

const INITIAL_STATE = { posts: [], errors: null };

export default function teamManagement(state=INITIAL_STATE, action) {
  

  switch(action.type) {
    case  REQUEST_APPROVAL_LIST_SUCCESS:
      return { posts: action.payload.data ? action.payload.data : action.payload, errors: null }
    case  REQUEST_APPROVAL_LIST_FAILURE:
      return { ...state, posts: [], errors: action.payload.response && action.payload.response.data.errors }
    default:
      return state;
  }
}
